module.exports = __webpack_public_path__ + "static/media/appstore.40362666.png";